
export default {
  defaultContent: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 40
  } as React.CSSProperties,
  icon: {
    fontSize: 94,
    color: '#D8D6D9',
    marginBottom: 24
  }
};

